import React from 'react'
import { BANKING_BOTTOM_CONTENT, CERTIFICATION_COURSE_PAGE_1, CERTIFICATION_DETAILS_PAGE_1, CERTIFICATION_HERO_PAGE_1 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { CERTIFICATION_ACCORDIAN_1 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'


const CertificationPage_1 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CERTIFICATION_HERO_PAGE_1}/>
     <CoursesAside {...CERTIFICATION_COURSE_PAGE_1}/>
     <CourseCard {...CERTIFICATION_DETAILS_PAGE_1}/>
     <Accordian {...CERTIFICATION_ACCORDIAN_1}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CertificationPage_1